import React from 'react'
import { SmallTickIcon, Pane, Text } from 'evergreen-ui'
import { useStatusContent } from '../../../config/roundContent'

const StatusRegister_4 = ({ DataRegister }) => {
  const row = DataRegister?.[0] || {}
  const { statusContent } = useStatusContent(row.ROB_ID, "4")
  const title = statusContent.titleText || 'ผู้มีสิทธิ์เข้าศึกษา'
  const body = statusContent.bodyText || ''

  return (
    <>
      <Pane
        color="#ffffff"
        backgroundColor="#164e00"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontWeight={700}
        marginBottom={0}
        display="flex" alignItems="center" justifyContent="center"
      >
        <Text color="#ffffff" fontWeight={700}>
          <SmallTickIcon /> {title}
        </Text>
      </Pane>
      <Pane
        color="#1b4332"
        backgroundColor="#d8f3dc"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontWeight={700}
        marginBottom={0}
        marginTop={8}
      >
        <Text color="#1b4332" fontWeight={700}>
          ผู้มีสิทธิ์เข้าศึกษา {row.QUOTA_NAME}{" "}
          {row.ROB_NAME !== null ? row.ROB_NAME : ""}
        </Text>
        <br />
        <Text color="#1b4332" fontWeight={700}>
          {row.Major1_faculty_name}{" "}
          {" หลักสูตร " + row.Major1_LEVEL_OPEN_NAME}
        </Text>
        <br />
        <Text color="#1b4332" fontWeight={700}>
          {row.Major1_MAJOR_ID + " : " + row.Major1_MAJOR_NAME}
        </Text>
      </Pane>
      <Pane
        hidden={row.REGISTER_ORDER_NUMBER === null ||
          row.REGISTER_ORDER?.includes(row.Major1_MAJOR_ID)}
        color="#8a2846"
        backgroundColor="#ffe5ec"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={14}
        margin={0}
        marginTop={8}
        fontWeight={700}
      >
        ผ่านการคัดเลือกเป็น {row.REGISTER_ORDER}
      </Pane>
      <Pane
        hidden={row.REGISTER_ORDER_NUMBER1 === null ||
          row.REGISTER_ORDER1?.includes(row.Major1_MAJOR_ID)}
        color="#8a2846"
        backgroundColor="#ffe5ec"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={14}
        margin={0}
        marginTop={8}
        fontWeight={700}
      >
        ผ่านการคัดเลือกเป็น {row.REGISTER_ORDER1}
      </Pane>

      {(body || statusContent.noteVisible) && (
        <Pane display="flex" flexDirection="column" marginTop={8}>
          {statusContent.noteVisible && statusContent.noteText ? (
            <Text color="red">{statusContent.noteText}</Text>
          ) : (
            <Text color="red">หมายเหตุ*</Text>
          )}
          {body ? <Text fontSize={"12px"}>{body}</Text> : null}
        </Pane>
      )}
    </>
  )
}

export default StatusRegister_4
